export enum RoleEnum {
  // super admin
  SUPER = 'super',
  // admin
  ADMIN = 'ADMIN',
  // tester
  TEST = 'test',
}
